import COLOR from '@fx-ui/color';
import React, { useState } from 'react';
import { LANG } from '~/constants';
import {
    get,
    getCurrentLocaleKey,
    map,
    getAnonymousLocaleKeyList,
    includes,
    switchLanguage,
    compact,
    isMobileUA
} from '~/utils';
import { IconFont } from '~/components';
import { Drawer, Menu, Popover } from '@fx-ui/fine-design';
import { DownOutlined } from '@fx-ui/fine-design/icons';
import classNames from 'classnames';
import { LOCALE_KEY } from '@fx-ui/intl';

interface ILangSwitchProps {
    className?: string;
    style?: React.CSSProperties;
    localeList?: LOCALE_KEY[];
    [key: string]: any;
}

const LangSwitch: React.FunctionComponent<ILangSwitchProps> = (props) => {
    const { className, style, localeList = getAnonymousLocaleKeyList() } = props;
    const [showSwitchPane, setShowSwitchPane] = useState<boolean>(false);
    const lang = getCurrentLocaleKey();
    const isMobile = isMobileUA();

    const switchLang = (key: string) => {
        switchLanguage(key);
        window.location.reload();
    };

    const renderMain = () => {
        return (
            <div
                className={classNames('fx-lang-switch', className, {
                    'is-mobile': isMobile
                })}
                style={style}
                onClick={() => setShowSwitchPane(true)}
            >
                <IconFont className="lang-icon" type="cover-language" />
                <span className="lang-name">{get(LANG, lang, '')}</span>
                {isMobile ? <DownOutlined className="switch-icon" /> : null}
            </div>
        );
    };

    const renderSwitchPane = () => {
        return (
            <Menu
                className="switch-menu"
                items={compact(
                    map(localeList, (value) => {
                        if (!includes(LOCALE_KEY, value)) {
                            return null;
                        }
                        const selected = value === lang;
                        return {
                            className: 'lang-item',
                            value,
                            label: LANG[value],
                            selected
                        };
                    })
                )}
                onAfterSelect={(item) => {
                    switchLang(item.value);
                }}
            />
        );
    };

    if (isMobile) {
        return (
            <>
                {renderMain()}
                <Drawer
                    className="fx-lang-switch-pane-mobile"
                    visible={showSwitchPane}
                    closable={false}
                    autoClose
                    maskStyle={{ background: COLOR.black, opacity: 0.25 }}
                    style={{ overflow: 'auto' }}
                    edge={{ height: 150 }}
                    onClose={() => setShowSwitchPane(false)}
                >
                    {renderSwitchPane()}
                </Drawer>
            </>
        );
    } else {
        return (
            <Popover
                className="fx-lang-switch-pane-pc"
                placement="bottom"
                trigger="click"
                hasPadding={false}
                arrow={false}
                visible={showSwitchPane}
                onVisibleChange={(visible) => setShowSwitchPane(visible)}
                content={renderSwitchPane()}
            >
                {renderMain()}
            </Popover>
        );
    }
};

export default LangSwitch;
